import {isMobile} from "react-device-detect";
import {useState} from "react";
import {API_BASE_URL} from "../ConstantsAndHelper";

function Login({emailUser, setEmailUser, setVerificationCode, setMainState}) {
    const [inputForm, setInputForm] = useState("emailInput");
    const [loginErrorMessage, setLoginErrorMessage] = useState("");

    let styleWidth = {width: '30rem'};
    if (isMobile) {
        styleWidth = {width: '19rem'};
    }

    function getEmailVerificationCode(emailUser) {
        fetch(`${API_BASE_URL}/verification`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({email: emailUser.trim()})
        })
            .then((response) => {
                if (!response.ok) {
                    throw new Error(response.status.toString());
                } else {
                    setInputForm("verificationCodeInput");
                    setLoginErrorMessage("");
                    setEmailUser(emailUser.trim());
                }
            })
            .catch((error) => {
                if(error.message === "401"){
                    setLoginErrorMessage("Sie müssen Ihre Email-Adresse an der Hochschule angeben. Andere Email-Adressen sind nicht zugelassen.");
                } else if(error.message === "404"){
                    setLoginErrorMessage("Die Email mit dem Verifizierungscode konnte nicht verschickt werden. Bitte versuchen Sie es zu einem späteren Zeitpunkt erneut.");
                } else {
                    setLoginErrorMessage("Es ist ein Problem aufgetreten. Bitte versuchen Sie es zu einem späteren Zeitpunkt erneut.");
                }
                setEmailUser("");
                setVerificationCode("");
                setInputForm("emailInput");
            });
    }

    function checkVerificationCodeAndLogin(emailUser, verificationCode) {
        fetch(`${API_BASE_URL}/login`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({email: emailUser.trim(), verificationCode: verificationCode.trim()})
        })
            .then((response) => {
                if (!response.ok) {
                    throw new Error(response.status.toString());
                } else {
                    setInputForm("emailInput");
                    setLoginErrorMessage("");
                    setEmailUser(emailUser.trim());
                    setVerificationCode(verificationCode.trim());
                    setMainState("courseOverview");
                }
            })
            .catch((error) => {
                if(error.message === "401"){
                    setLoginErrorMessage("Der Verifizierungscode ist nicht korrekt oder abgelaufen. Bitte versuchen Sie den Login erneut.");
                } else {
                    setLoginErrorMessage("Es ist ein Problem aufgetreten. Bitte versuchen Sie es zu einem späteren Zeitpunkt erneut.");
                }
                setInputForm("emailInput");
                setEmailUser("");
                setVerificationCode("");
            });
    }

    function submitEmail(formData) {
        const emailUser = formData.get("emailUser");
        setInputForm("spinner");
        setLoginErrorMessage("");
        getEmailVerificationCode(emailUser);
    }

    function submitVerificationCode(formData) {
        const verificationCode = formData.get("verificationCode");
        setInputForm("spinner");
        setLoginErrorMessage("");
        checkVerificationCodeAndLogin(emailUser,verificationCode);
    }

    let loginErrorMessageDiv = "";
    if (loginErrorMessage!=="") {
        loginErrorMessageDiv =
            <div className="d-flex justify-content-center">
                <div className="alert alert-secondary mt-3" role="alert" style={styleWidth}>
                    <i className="bi bi-exclamation-triangle"></i> {loginErrorMessage}
                </div>
            </div>;
    }

    let loginForm = <form action={submitEmail} className="form-floating mt-3 mb-3" style={styleWidth}>
        <div className="form-group mb-3">
            <small className="form-text text-muted">Bitte geben Sie die Email-Adresse an, die Sie an der Hochschule haben.
            </small>
        </div>
        <div className="form-floating mb-3">
            <input name="emailUser" type="email" className="form-control mb-3" id="emailInput"
                   placeholder="...@hochschule-trier.de"/>
            <label htmlFor="emailInput">Ihre Email-Adresse an der Hochschule (...@hochschule-trier.de)</label>
        </div>
        <button type="submit" className="btn btn-outline-primary" style={styleWidth}><i className="bi bi-envelope"></i> Verifizierungscode per Email anfordern</button>
    </form>;

    if (inputForm === "spinner") {
        loginForm = <div><div className="form-group mt-3">
                        <small className="form-text text-muted mt-3">Ihre Anfrage ist in Bearbeitung. Bitte warten.
            </small></div>
            <div className="spinner-border mt-3" role="status">
                <span className="visually-hidden">Loading...</span></div></div>;
    } else if (inputForm === "verificationCodeInput") {
        loginForm = <form action={submitVerificationCode} className="form-floating mt-3 mb-3" style={styleWidth}>
            <div className="form-group mb-3">
                <small className="form-text text-muted">Bitte geben Sie den Verifizierungscode ein, der an
                    Ihre Email-Adresse gesendet wurde. Der Eingang der Email kann möglicherweise ein paar Minuten dauern.
                </small>
            </div>
            <div className="form-floating mb-3">
                <input name="verificationCode" type="password" className="form-control mb-3"
                       id="verificationCodeInput"
                       placeholder="Verifizierungscode "/>
                <label htmlFor="verificationCodeInput">Verifizierungscode eingeben (siehe Email)</label>
            </div>
            <button type="submit" className="btn btn-outline-primary" style={styleWidth}><i
                className="bi bi-person-check"></i> Einloggen
            </button>
        </form>
    }

    return (
        <div>
            {loginErrorMessageDiv}
            <div className="d-flex justify-content-center">
                {loginForm}
            </div>
        </div>
    );
}

export default Login;